import { useEffect, useState } from "react";
import clsx from "clsx";
import { API_BASE } from "@/lib/apiClient";
import { initialsFromName } from "@/pages/kontakte/geschaeftspartnerColumns";

function geschaeftspartnerLogoSrc(
  partnerId: number,
  updatedAt?: string | null,
): string {
  const stamp = updatedAt ? `?v=${encodeURIComponent(updatedAt)}` : "";
  const path = `/kontakte/geschaeftspartner/${partnerId}/logo${stamp}`;
  return API_BASE ? `${API_BASE}${path}` : path;
}

/**
 * Firmenlogo oder Initialen. Das Bild kommt vom authentifizierten Logo-Endpunkt;
 * ohne Logo oder bei Ladefehler bleiben die Initialen stehen.
 */
export function GeschaeftspartnerLogo({
  partnerId,
  name,
  hasLogo,
  logoUpdatedAt,
  className,
}: {
  partnerId?: number | null;
  name: string;
  hasLogo?: boolean | null;
  logoUpdatedAt?: string | null;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);
  const id = Number(partnerId);
  const showImage = Boolean(hasLogo) && Number.isFinite(id) && id > 0 && !failed;

  useEffect(() => {
    setFailed(false);
  }, [id, logoUpdatedAt, hasLogo]);

  return (
    <span
      className={clsx(
        "inline-flex shrink-0 items-center justify-center overflow-hidden bg-accent font-semibold tracking-wide text-label-on-accent",
        className,
      )}
      aria-hidden
    >
      {showImage ? (
        <img
          src={geschaeftspartnerLogoSrc(id, logoUpdatedAt)}
          alt=""
          className="h-full w-full bg-white object-contain"
          onError={() => setFailed(true)}
        />
      ) : (
        initialsFromName(name)
      )}
    </span>
  );
}
